module.exports = __webpack_public_path__ + "img/btc.ce06a59b.svg";